import { CHARACTER_VISIBILITY, CharacterHandlerReturnType } from "@next-platform/client-common-core";
import type { RulebookAttachmentChange } from "@next-platform/client-common-core/rulebook/attach/useRulebookAttachmentSelection";
import { Lorebook } from "@next-platform/packages-ts-types";

import { CUSTOM_ERROR_MESSAGES } from "@/constants/ErrorMessages";
import { IDraftChracter } from "@/types";

// do not change values as it will used in the API call payload
export enum CharacterFormFields {
  AVATAR = "avatar_url",
  NAME = "name",
  TITLE = "title",
  PERSONA = "persona",
  GREETING = "greeting",
  SCENARIO = "scenario",
  DIALOGUE = "dialogue",
  VISIBILITY = "visibility",
  GUIDELINES = "guidelines",
  TAGS = "tags",
  DEFINITION_VISIBLE = "definition_visible",
  GROUP_ADDABLE = "group_addable",
}

export interface SuggestedFieldButtonProps {
  field: string;
  label?: string;
}

export type CharacterFormProps = {
  id: string;
  /** Canonical server id when it differs from `id` (the same key saves write under). */
  // TODO(karlbernard2): [NX-13090] prop mirrors the API's snake_case character_id; drop the suppression when props are camelCased.
  // eslint-disable-next-line @typescript-eslint/naming-convention -- the canonical id comes from the API's character_id field
  character_id?: string;
  name: string;
  avatar_url: string;
  greeting: string;
  visibility: CHARACTER_VISIBILITY;
  title: string;
  dialogue: string;
  persona: string;
  scenario: string;
  onSave?: (
    draft: IDraftChracter,
    currentLorebooks: Lorebook[],
    initialLorebooks: Lorebook[],
    rulebookChange?: RulebookAttachmentChange,
  ) => CharacterHandlerReturnType<unknown>;
  setIsSubmitForManualReview: (isSubmitForManualReview: boolean) => void;
  onCancel: () => void;
  allowImport: boolean;
  isSubmitting: boolean;
  submitError: string;
  guidelines: boolean;
  tags: string[];
  view: boolean;
  definition_visible: boolean;
  groupAddable?: boolean;
  isEdit: boolean;
  moderationReport?: {
    moderation_status: string;
  };
  draftId: string;
  isAlreadyDraft: boolean;
  errorCode: string | null;
  submitForManualReview: boolean;
  lorebooks: Lorebook[];
  /** Rulebook picked in a saved local draft (`null` = the draft removed it); absent when not opened from a draft. */
  rulebook_id?: string | null;
  voice_id?: string;
  handleModerationSubmitConfirmClose: () => void;
  stateShowModerationSubmitConfirm: boolean;
  stateModerationConfirmLoading: boolean;
  handleModerationSubmitConfirm: () => Promise<void | { error: string }>;
};

export type CustomErrorMessage = keyof typeof CUSTOM_ERROR_MESSAGES;

export type DeepTag = string | { value: DeepTag };
